class AnnounceTicker {
    constructor(container) {
        this.container = container;

        if (!this.container) return;

        this.tickerList = this.container.querySelectorAll(".js-ticker-item");
        this.animationOnClass = "ticker-visibility-on";
        this.animationOffClass = "ticker-visibility-off";

        this.init();
    }

    init() {
        let t;
        this.activeIndex = 0;

        const startTicker = () => {
            if (this.tickerList && this.tickerList.length) {
                const activeItem = this.tickerList[this.activeIndex];
    
                t = setTimeout(() => {
                    activeItem.classList.add(this.animationOffClass);
    
                    activeItem.onanimationend = () => {
                        activeItem.classList.remove(this.animationOffClass);
                        activeItem.classList.add("hidden");
    
                        this.activeIndex++;
                        
                        if (this.activeIndex === this.tickerList.length) {
                            this.activeIndex = 0;
                        }
    
                        const newItem = this.tickerList[this.activeIndex];
    
                        newItem.classList.remove("hidden");
                        newItem.classList.add(this.animationOnClass);
    
                        newItem.onanimationend = () => {
                            newItem.classList.remove(this.animationOnClass);
                            startTicker();
                        }
                    }
                }, 3000);
            }
        }

        startTicker();
    }
}

document.addEventListener("DOMContentLoaded", () => {
    const tickerContainerList = document.querySelectorAll(".js-ticker-container");

    if(tickerContainerList && tickerContainerList.length) {
        tickerContainerList.forEach(container => {
            new AnnounceTicker(container);
        })
    }
})